import Maintenance from '@/views/Maintenance/Index'
import MaintenanceAccidents from '@/views/Maintenance/Accidents/Index'
import MaintenanceAccidentsAccident from '@/views/Maintenance/Accidents/Accident'

export default [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance,
        meta: {
            title: 'Zgłaszanie awarii',
            menuRendered: true,
            menuTitle: 'Zgłaszanie awarii',
            permission: 'accidents',
            icon: 'mdi-alert',
        },
        redirect: { name: 'accidents' },
        children: [
            {
                path: '/maintenance/accidents',
                name: 'accidents',
                component: MaintenanceAccidents,
                meta: {
                    title: 'Zgłaszanie awarii',
                    requiresAuth: true,
                    permission: 'accidents'
                },
            },
            {
                path: '/maintenance/accidents/edit/:id',
                name: 'maintenanceAccidentsEdit',
                component: MaintenanceAccidentsAccident,
                meta: {
                    title: 'Awaria / Zarządzanie awarią',
                    requiresAuth: true,
                    permission: 'accidents',
                },
            },
        ],
    },
]
